import { useState } from "react";

import FtmLiveMap from "./ftmLiveMap";
import MapBtn from "./MapBtn";

const Map = () => {
    const [mapType, setMapType] = useState("all");

    const handleMapType = (type) => setMapType(type);

    return (
        <div className="card h-100">
            <div className="card-header pb-0 p-3">
                <div className="d-flex justify-content-between">
                    <h6 className="my-auto my-0">TRADESPERSONS LIVE MAP</h6>
                    <div className="nav-wrapper position-relative ms-auto w-45">
                        <MapBtn handleMapType={handleMapType}/>
                    </div>
                </div>
            </div>
            <div className="card-body p-3">
                {/* <div ref={ref} style={{ width: '100%', height: 400 }} /> */}
                <FtmLiveMap type={mapType} />
            </div>
        </div>
    );
}

export default Map;